
import { defineComponent, ref, computed, onMounted } from 'vue'

export default defineComponent({
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    number: {
      type: [Number, String],
      required: true
    },
    error: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: {
    change: (value: number | string) => true
  },
  setup (props, { emit }) {
    const inFocus = ref(false)
    const inputNumber = ref<number | string>('')
    const inputElement = ref()
    const numberWithComma = computed(() => {
      if (typeof props.number === 'number') {
        return props.number.toLocaleString('en-US')
      } else {
        return props.number
      }
    })

    onMounted(() => {
      inputNumber.value = props.number
    })

    const onFocusIn = () => {
      inFocus.value = true
      // v-ifの切り替え前に呼ばれるため、そのまま呼ぶと関数が見つからずundefinedエラーになる
      // v-ifのレンダリングが終わってからfocus関数を呼び出すため、setTimeout関数を使用
      setTimeout(() => {
        inputElement.value.focus()
      })
    }

    const onFocusOut = () => {
      inFocus.value = false
    }

    const onChange = () => {
      emit('change', inputNumber.value)
    }

    return {
      inFocus,
      numberWithComma,
      inputNumber,
      onFocusIn,
      onFocusOut,
      onChange,
      inputElement
    }
  }
})
